<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M19.4 1.9c.2.1.3.2.4.4.1.1.2.3.2.4v4l.9.6c.6.4 1.2 1 1.5 1.7.4.7.6 1.5.6 2.2 0 .8-.2 1.5-.6 2.2-.4.7-.9 1.3-1.5 1.7l-.9.7v3c0 .2-.1.4-.1.5-.1.2-.2.3-.4.4-.2.1-.4.1-.5.1-.2 0-.4-.1-.5-.2l-.1-.1-.4-.2c-.2-.2-.6-.4-1-.7-.8-.5-1.7-1.1-2.5-1.5-1.4-.6-2.8-1.1-3.9-1.5l-1.2-.3c-.4.7-.5 1.5-.4 2.2.1.7.5 1.4 1.1 1.8 1.2 1 .6 2.9-1 2.9H6c-.2 0-.4-.1-.6-.2-.2-.1-.3-.3-.4-.4l-.4-.9c-.8-1.9-.9-4.1-.1-6v-.1c-1.1-.3-2.1-1-2.8-1.9-.7-1-1-2.1-.8-3.3.1-1.2.7-2.2 1.6-3 .9-.8 2-1.2 3.2-1.2h5.1c1.1-.1 2.5-.3 3.8-.9.8-.3 1.7-.9 2.5-1.4l1.2-.9h.1c.1-.1.3-.2.5-.2.2-.1.4 0 .5.1zM8 7.2H5.8c-.7 0-1.4.3-1.9.8S3.1 9.1 3 9.8c-.1.7.2 1.4.6 1.9.4.5 1.1.9 1.7 1l.8.1 1.9.3V7.2zm2 6.3c.3.1.7.2 1.2.3 1.2.3 2.7.9 4.2 1.6.8.4 1.8 1 2.6 1.5V4.7c-.8.5-1.7 1.1-2.6 1.5-1.6.7-3.2.9-4.4 1-.4 0-.7 0-1 .1v6.2zM7.4 15l-.7-.1-.2.5c-.6 1.5-.5 3.1.1 4.5l.1.3h1.6c-.6-.7-1-1.6-1.2-2.5-.2-.9-.1-1.8.3-2.7zM20 13.4c.3-.3.6-.6.7-.9.2-.4.3-.8.3-1.2 0-.4-.1-.8-.3-1.2-.2-.4-.4-.7-.7-.9v4.2z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
